// extracted by mini-css-extract-plugin
module.exports = {"container":"menusvg_container__37MUC","active":"menusvg_active__2xiyi","close":"menusvg_close__2BAi2"};